import api from '@/shared/api/api';

import {
  registryAssetToDomain,
  registryFamilyToWire,
  registrySourceKindToWire,
} from './scribeCatalogConv';
import type {
  RegistryAssetFamily,
  RegistryAssetList,
  RegistrySourceKind,
} from './scribeCatalogTypes';
import { callScribe } from './scribeError';

export type {
  DocumentTemplateType,
  RegistryAsset,
  RegistryAssetFamily,
  RegistryAssetList,
  RegistryOriginKind,
  RegistrySourceKind,
} from './scribeCatalogTypes';

export type ListRegistryAssetsParams = {
  organizationId: string;
  family?: RegistryAssetFamily;
  sourceKind?: RegistrySourceKind;
  query?: string;
  language?: string;
  offset?: number;
  limit?: number;
  signal?: AbortSignal;
};

export const listRegistryAssets = async (
  params: ListRegistryAssetsParams,
): Promise<RegistryAssetList> => {
  const response = await callScribe(
    api.registry.list(
      {
        OrganizationID: params.organizationId,
        Family: registryFamilyToWire(params.family),
        SourceKind: registrySourceKindToWire(params.sourceKind),
        Query: params.query,
        Language: params.language,
        Offset: params.offset,
        Limit: params.limit,
      },
      { signal: params.signal },
    ),
  );

  return {
    items: response.Assets.map(registryAssetToDomain),
    total: response.Total,
    availableLanguages: response.AvailableLanguages,
  };
};

export const registryApi = {
  listRegistryAssets,
};
